import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { TreeData, TreeItem } from "@atlaskit/tree"
import { GroupedProgress, GroupedTokens } from "../../models/license/apiTypes"
import { v4 as uuidv4 } from "uuid"
import { ItemId } from "@atlaskit/tree/types"
import { mutateTreeTyped } from "../../utility/common/tree"
import { ToggleLicenceTree } from "./types"
import i18next from "i18next"

export interface licenseState {
    licenseTree: TreeData
    licenseGrouped?: GroupedTokens
    licenseProgress?: GroupedProgress
    selectedLicense: ItemId
}

const rootElem: TreeItem = {
    id: uuidv4(),
    children: [],
    hasChildren: true,
    isExpanded: true,
    isChildrenLoading: false,
    data: {
        title: i18next.t("license:root")
    }
}

const initialState: licenseState = {
    selectedLicense: rootElem.id,
    licenseTree: {
        rootId: rootElem.id,
        items: {
            [rootElem.id]: rootElem
        }
    }
}

const license = createSlice({
    name: "license",
    initialState,
    reducers: {
        setLicenseGrouped(state, action: PayloadAction<GroupedTokens>) {
            state.licenseGrouped = action.payload
        },
        setLicenseProgress(state, action: PayloadAction<GroupedProgress>) {
            state.licenseProgress = action.payload
        },
        toggleLicenseTree(state, action: PayloadAction<ToggleLicenceTree>) {
            const { CategoryId, IsExpanded } = action.payload
            if (state.licenseTree) {
                state.licenseTree = mutateTreeTyped(state.licenseTree, CategoryId, {
                    isExpanded: IsExpanded
                })
            }
        },
        setLicenseTree(state, action: PayloadAction<GroupedTokens>) {
            const groupedData = action.payload
            const typeKeys = Object.keys(groupedData)

            const treeElemsFromKeys = typeKeys.reduce<Record<ItemId, TreeItem>>((acc, limitationId) => {
                acc[limitationId] = {
                    id: limitationId,
                    children: [],
                    hasChildren: false,
                    isExpanded: false,
                    isChildrenLoading: false,
                    data: {
                        title: groupedData[limitationId][0].Payload.Limitation.Title
                    }
                }
                return acc
            }, {})

            const newRoot = {
                ...rootElem,
                children: typeKeys
            }

            state.licenseTree = {
                rootId: newRoot.id,
                items: {
                    [newRoot.id]: newRoot,
                    ...treeElemsFromKeys
                }
            }
        },
        setSelectedLicence(state, action: PayloadAction<string>) {
            state.selectedLicense = action.payload
        }
    }
})

export const LicenseReducer = license.reducer
export const LicenseActions = license.actions
